export default {
  ws_url: "ws://admin.win2biz.cn/prod-api" //正式
  // ws_url: "ws://114.55.85.57:8891" //测试
}

